import styled from "styled-components";

import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const EmploymentTypeDescription = styled.p<{
  readonly $hasTopMargin?: boolean;
}>`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue3};
  margin: ${({ $hasTopMargin }) => ($hasTopMargin ? "3px 4px 0" : "0 4px")};
`;
